module.exports = __webpack_public_path__ + "static/media/card1.d778b1ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/card1.jpg
// module id = 875
// module chunks = 0